"use client";

import { useEffect, useState } from "react";
import {
    SITE_BUILDER_COUNTDOWN_TICK_MS,
    siteBuilderCountdownItems,
} from "./siteBuilderCountdownModel";
import type {
    SiteBuilderCountdownItem,
} from "./siteBuilderCountdownModel";

export {
    SITE_BUILDER_COUNTDOWN_LABEL_KEYS,
    SITE_BUILDER_COUNTDOWN_LABELS,
    SITE_BUILDER_COUNTDOWN_LANGUAGE_CODES,
    SITE_BUILDER_COUNTDOWN_TICK_MS,
    siteBuilderCountdownItems,
    siteBuilderCountdownLabel,
    siteBuilderCountdownValues,
} from "./siteBuilderCountdownModel";
export type {
    SiteBuilderCountdownItem,
    SiteBuilderCountdownLabelKey,
    SiteBuilderCountdownLanguageCode,
} from "./siteBuilderCountdownModel";

export function useSiteBuilderCountdown(
    targetDate: string,
): readonly SiteBuilderCountdownItem[] {
    const [now, setNow] = useState<number | null>(null);

    useEffect(() => {
        setNow(Date.now());
        const timer = window.setInterval(
            () => setNow(Date.now()),
            SITE_BUILDER_COUNTDOWN_TICK_MS,
        );

        return () => window.clearInterval(timer);
    }, []);

    const targetTimestamp = Date.parse(targetDate.trim().replace(" ", "T"));
    const hydrationSafeNow = Number.isFinite(targetTimestamp) ? targetTimestamp : 0;

    return siteBuilderCountdownItems(targetDate, now ?? hydrationSafeNow);
}
